const $ = jQuery.noConflict();

class InpageNav {
    constructor() {
        this.body = $('body');
        this.header = this.body.find('.main-header:not(.static)');
        this.nav = this.body.find('.inpage-nav');
        this.navWrapper = this.nav.find('.inpage-nav__wrapper');
        this.navLinks = this.nav.find('.inpage-nav__item');
        this.menuTrigger = this.nav.find('.inpage-nav__menu-trigger');
        this.menu = this.nav.find('.inpage-nav__menu');
        this.sections = $(this.body.find('.page-content').children('section[id]').get().reverse());
        this.sectionsArr = [];
        this.lastPosition = 0;
    }

    init() {
        this.mapSections();
        this.scrolled();
        this.menuTrigger.on('click', function toggleActive() {
            $(this).toggleClass('active');
        });
        this.navLinks.on('click', (e) => {
            const link = $(e.target);
            this.navLinks.removeClass('active');
            link.addClass('active');
            this.scrollNavWrapper(link);
        });
    }

    mapSections() {
        this.sections.each((i, item) => {
            const sectionID = $(item).attr('id');
            this.sectionsArr[sectionID] = this.navLinks.filter((i, e) => e.getAttribute('href').substring(1) === sectionID);
        });
    }

    stickNav() {
        const headerHeight = this.header.outerHeight();
        const navOffsetTop = this.nav.offset().top;
        const windowScrollTop = $(window).scrollTop();

        if (windowScrollTop > navOffsetTop - headerHeight) {
            this.nav.addClass('sticky');
            this.navWrapper.css('top', `${headerHeight}px`);

            if (windowScrollTop > navOffsetTop) {
                this.body.addClass('hide-header');
            } else {
                this.body.removeClass('hide-header');
            }
        } else {
            this.body.removeClass('hide-header');
            this.nav.removeClass('sticky');
            this.navWrapper.css('top', '');
            if ( this.body.hasClass('admin-bar')) {
                this.header.css('top', `32px`);
            } else {
                this.header.css('top', '0' );
            }
        }

        // if (this.lastPosition > windowScrollTop && !this.body.hasClass('smooth-scroll')) {
        //     this.body.removeClass('scroll-down').addClass('scroll-up');
        // } else {
        //     this.body.removeClass('scroll-up').addClass('scroll-down');
        // }

        this.lastPosition = windowScrollTop;
    }

    highlightNavItem() {
        if (this.body.hasClass('smooth-scroll')) {
            return;
        }
        const scrollPosition = $(window).scrollTop() + this.nav.outerHeight() + this.header.outerHeight();

        this.sections.each((i, item) => {
            const currentSection = $(item);
            const mt = parseInt(currentSection.css('margin-top'), 10);
            const pt = parseInt(currentSection.css('padding-top'), 10);
            const extraOffset = (mt > 0 && pt === 0) ? mt : 0;
            const sectionTop = currentSection.offset().top - extraOffset;

            if (scrollPosition >= sectionTop) {
                const link = this.sectionsArr[currentSection.attr('id')];
                if (!link.hasClass('active')) {
                    this.navLinks.removeClass('active');
                    link.addClass('active');
                    this.scrollNavWrapper(link);
                }
                return false;
            }
        });
    }

    scrollNavWrapper(link = false) {
        if (!link || !link.length ) {
            return;
        }
        const wrapper = this.nav.find('.inpage-nav__nav');
        const wrapperBounding = wrapper[0].getBoundingClientRect();
        const bounding = link[0].getBoundingClientRect();
        const offsetRight = bounding.right;
        const offsetLeft = bounding.left;
        const staticOffset = 0;

        const condLeft = offsetLeft - staticOffset < wrapperBounding.left;
        const condRight = offsetRight + staticOffset > wrapperBounding.right;

        let offset = 0;
        if (condLeft) {
            offset = wrapper.scrollLeft() + offsetLeft + staticOffset - wrapperBounding.left;
        } else if (condRight) {
            offset = wrapper.scrollLeft() + offsetRight + staticOffset - wrapperBounding.right;
        }

        if (condRight || condLeft) {
            wrapper.stop().animate({
                scrollLeft: parseInt(offset, 10),
            }, 200);
        }
    }

    scrolled() {
        if (!this.nav.length || this.body.hasClass('menu-open')) {
            return
        }

        this.stickNav();
        this.highlightNavItem();
    }

    hideOutsideClick(e) {
        if (this.menuTrigger.hasClass('active') && !this.menuTrigger.is(e.target) && this.menu.has(e.target).length === 0 && !this.menu.is(e.target)) {
            this.menuTrigger.removeClass('active');
        }
    }
}

export default new InpageNav;
